"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mround_1 = require("./mround");
/**
 * obliczanie wartości procentowej
 * @param value wartość
 * @param totalValue wartośc odpowiadająca 100%
 */
function percent(value, totalValue) {
    if (totalValue == 0) {
        return 0;
    }
    else if ((value < 0 && totalValue > 0) || (value > 0 && totalValue < 0)) {
        return 0;
    }
    else {
        return mround_1.default((value * 100) / totalValue, 8);
    }
}
exports.default = percent;
//# sourceMappingURL=percent.js.map